import React from 'react';
import { tongueData } from './TongueData';
interface TongueTableProps {
  searchQuery: string;
}
export const TongueTable: React.FC<TongueTableProps> = ({
  searchQuery
}) => {
  const filteredData = tongueData.filter(item => Object.values(item).some(value => value.toLowerCase().includes(searchQuery.toLowerCase())));
  return <div className="overflow-x-auto" data-id="element-8">
      <table className="w-full border-collapse" data-id="element-9">
        <thead data-id="element-10">
          <tr data-id="element-11">
            <th className="border border-gray-300 p-2 bg-rose-100 text-left" data-id="element-12">
              Feature
            </th>
            <th className="border border-gray-300 p-2 bg-rose-100 text-left" data-id="element-13">
              Subtype/Detail
            </th>
            <th className="border border-gray-300 p-2 bg-rose-100 text-left" data-id="element-14">
              TCM State/Pattern
            </th>
            <th className="border border-gray-300 p-2 bg-rose-100 text-left" data-id="element-15">
              Condition/Meaning
            </th>
          </tr>
        </thead>
        <tbody data-id="element-16">
          {filteredData.map((item, index) => <tr key={index} className="hover:bg-yellow-50" data-id="element-17">
              <td className="border border-gray-300 p-2" data-id="element-18">{item.feature}</td>
              <td className="border border-gray-300 p-2" data-id="element-19">{item.subtype}</td>
              <td className="border border-gray-300 p-2" data-id="element-20">{item.tcmState}</td>
              <td className="border border-gray-300 p-2" data-id="element-21">{item.condition}</td>
            </tr>)}
        </tbody>
      </table>
    </div>;
};